import { useTranslation } from "react-i18next";
import { EnrolledBeneficiaryType } from "@/types/beneficiaries";
import { formatVestingSchedule } from "@/utils/generalUtilities";
import SavingsCard from "@/components/Common/Cards/SavingsCard";
import ProgressCard from "@/components/Common/Cards/ProgressCard";

interface VestingSectionProps {
  beneficiary: EnrolledBeneficiaryType;
  calculations: {
    totalEmployerContrib: number;
    vestedAmount: number;
    vestingPercentage: string;
  };
}

const VestingSection = ({ beneficiary, calculations }: VestingSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 mt-5 gap-5">
      <SavingsCard
        title={t("home.beneficiary_card.employer_contributions")}
        amount={calculations.totalEmployerContrib}
      />
      <ProgressCard
        headerOne={`${t("home.beneficiary_card.vesting_schedule")}`}
        headerOneDesc={` ${formatVestingSchedule(beneficiary.vestingScheduleName || "")}`}
        headerTwo={`${t("home.beneficiary_card.vesting_progress")}`}
        headerTwoDesc={`${calculations.vestingPercentage}%`}
        current={calculations.vestedAmount}
        target={calculations.totalEmployerContrib}
        percentage={calculations.vestingPercentage}
        className="lg:col-span-2"
        showTooltip
        tooltipText={
          beneficiary.vestingScheduleName === "ThreeYear"
            ? t("home.beneficiary_card.tooltips.three_year_vesting")
            : beneficiary.vestingScheduleName === "FiveYear"
              ? t("home.beneficiary_card.tooltips.five_year_vesting")
              : ""
        }
      />
    </div>
  );
};

export default VestingSection;
